// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
Messages.FormView = class FormView {
  render() {
    return JST['messages/templates/form'](this.data);
  }
  after_render(container) {
    const form = container.find('.new_message');
    const button = form.find('.submit-reply-button');
    const body = form.find('textarea');
    const errorText = form.find('.js-error-text');
    body.attr('placeholder', this.placeholder);
    body.autosize({
      callback() {
        form.trigger('resize_modal');
      }
    });
    if (!this.data.message_thread_id) {
      new Messages.RecipientFinder(form.find('.recipient-input'));
    }
    button.on('click', e => {
      e.preventDefault();
      errorText.text('');
      button.button('loading');
      Messages.send_message({
        data: form.serialize()
      }).always(() => {
        button.button('reset');
      }).done(function () {
        var _this_success, _this;
        (_this_success = (_this = this).success) === null || _this_success === void 0 ? void 0 : _this_success.call(_this, ...arguments);
      }.bind(this)).error(xhr => {
        let errorMessage = 'Sorry, an error occurred. Please try again.';
        if (xhr.status === 422) {
          try {
            const response = JSON.parse(xhr.responseText);
            const errors = Object.values(response.errors).flat();
            if (errors[0]) {
              errorMessage = errors[0];
            }
          } catch (error) {}
        }
        // Use default error message if JSON parsing fails
        errorText.text(errorMessage);
      });
    });
  }
  constructor(data, success) {
    this.data = data;
    this.success = success;
    this.placeholder = this.data.placeholder || 'Write a message';
  }
};